export default {
  // #region首页
  main_collection_function: 'Favorietenfunctie',
  main_menu_bar_management: 'Menubalkbeheer',
  // #endregion

  // #region Header
  main_header_download_app: 'APP Downloaden',
  main_header_recent_visit: 'Recent Bezocht',
  main_header_placeholder: 'Zoeken',
  main_header_IT_system: 'IT Systeem',
  main_header_todo_center: 'Takencentrum',
  main_header_message_remind: 'Berichtherinneringen',
  main_header_change_SYS_password: 'Wachtwoord Wijzigen',
  main_header_log_out: 'Uitloggen',
  main_header_log_out_tip: 'Weet u zeker dat u wilt uitloggen?',
  main_header_log_out_title: 'Bevestiging Uitloggen',
  main_header_confirm: 'Bevestigen',
  main_header_cancel: 'Annuleren',
  main_header_change_name: 'Naam',
  main_header_change_Work_number: 'Personeelsnummer',
  main_header_old_password: 'Oud Wachtwoord',
  main_header_old_password_placeholder: 'Voer het initiële wachtwoord in',
  main_header_new_password: 'Nieuw Wachtwoord',
  main_header_new_password_placeholder: 'Voer een nieuw wachtwoord in',
  main_header_confirm_password: 'Bevestig Wachtwoord',
  main_header_confirm_password_placeholder: 'Bevestig het wachtwoord',
  main_header_messageObj_prompt: 'Hint',
  main_header_messageObj_length: 'Wachtwoordlengte moet 8~16 tekens zijn',
  main_header_messageObj_three_condition: 'Moet minimaal 3 soorten bevatten: hoofdletters, kleine letters, cijfers, speciale symbolen',
  main_header_messageObj_no_repeat: 'Niet toegestaan: 3 of meer opeenvolgende of herhaalde cijfers (bijv. 345, 333)',
  main_header_messageObj_old_new_different: 'Nieuw wachtwoord mag niet hetzelfde zijn als het oude',
  main_header_messageObj_twice_different: 'De twee ingevoerde wachtwoorden moeten overeenkomen',
  main_header_change_success: 'Wijziging succesvol',
  main_header_refresh: 'Vernieuwen',
  main_header_close: 'Sluiten',
  main_header_close_all: 'Alles Sluiten',
  main_header_close_addition: 'Alles Sluiten Behalve Deze',
  main_header_close_right: 'Alles Rechts Sluiten',
  main_header_close_left: 'Alles Links Sluiten',
  // #endregion

  // #region 首页
  main_home_home_name: 'Home',
  main_home_todo_title: 'Mijn Taken',
  main_home_todo_more: 'Meer',
  main_home_todo_checkAll: 'Alles Selecteren',
  main_home_todo_batchProcess: 'Batchverwerking',
  main_home_todo_complaint: 'Her-Toewijzen',
  main_home_todo_approve: 'Goedkeuren',
  main_home_todo_reject: 'Afwijzen',
  main_home_todo_toDealWith: 'Afhandelen',
  main_home_todo_work_dealed: 'Gefeliciteerd! Je hebt al je werk afgerond!',
  main_home_todo_no_data: 'Geen gegevens beschikbaar',
  main_home_todo_current_select: 'Momenteel geselecteerd',
  main_home_todo_data_num: 'gegevenselementen',
  main_home_todo_all: 'Alle',
  main_home_todo_approve_tip: 'Weet u zeker dat u deze gegevens wilt goedkeuren?',
  main_home_todo_approve_title: 'Goedkeuren',
  main_home_todo_confirm: 'Bevestigen',
  main_home_todo_cancel: 'Annuleren',
  main_home_todo_approve_success: 'Succesvol goedgekeurd!',
  main_home_todo_reject_title: 'Afwijzen',
  main_home_todo_reject_reason: 'Vul de reden voor afwijzing in',
  main_home_todo_reject_success: 'Succesvol afgewezen!',
  main_home_quick_title: 'Snelle Toegang',
  main_home_quick_create: 'Snelkoppeling Maken',
  main_home_quick_cancel_common: 'Uit Favorieten Verwijderen',
  main_home_quick_set_common: 'Als Favoriet Instellen',
  main_home_quick_sort: 'Sorteren',
  main_home_quick_recommend: 'Als Aanbevolen App Instellen',
  main_home_quick_add_common: 'Aan Favorieten Toevoegen',
  main_home_quick_no_data: 'Geen gegevens beschikbaar',
  main_home_quick_cancel_common_success: 'Succesvol uit favorieten verwijderd!',
  main_home_quick_set_common_success: 'Succesvol als favoriet ingesteld!',
  main_home_quick_recommend_success: 'Succesvol als aanbevolen app ingesteld!',
  main_home_report_transhipment: 'Overslag - Luchtvracht',
  main_home_report_no_data: 'Geen gegevens beschikbaar',
  main_home_report_clearance: 'Douane - Inklaringsdocumenten',
  main_home_report_risk_control: 'Douane - Risicobeheer',
  main_home_micro_loading: 'Systeem laden...',
  main_header_full_screen: 'Volledig Scherm',
  main_header_forced_refresh: 'Geforceerd Vernieuwen',
  // #endregion

  // #region request tips
  main_request_tip_exist_environ: 'Omgeving bestaat niet',
  main_request_tip_login_expired: 'Login verlopen, log opnieuw in',
  main_request_tip_no_legal: 'Geen toestemming, neem contact op met de beheerder',
  main_request_tip_server_error: 'Serverfout, neem contact op met de beheerder',
  main_request_504_error: 'Gateway time-out, probeer opnieuw',
  main_request_tip_system_error: 'Systeemfout, neem contact op met de beheerder',
  main_request_tip_timeout: 'Verzoek time-out, vernieuw en probeer opnieuw',
  main_request_copy_success: 'Succesvol gekopieerd',
  main_request_tip_confirm: 'Bevestigen',
  main_request_tip_cancel: 'Annuleren',
  main_request_tip_delete_success: 'Succesvol verwijderd',
  // #endregion

  // #region 登录、忘记密码
  main_login_welcome_system: 'Welkom bij het GOFO-systeem',
  main_login_loading_failure: 'Omgeving laden mislukt, vernieuw en probeer opnieuw',
  main_login_morning_greetings: 'Goedemorgen',
  main_login_noon_greetings: 'Goedemiddag',
  main_login_afternoon_greetings: 'Goedemiddag',
  main_login_night_greetings: 'Goedenavond',
  main_login_account: 'Account',
  main_login_placeholder_input: 'Voer in',
  main_login_password: 'Wachtwoord',
  main_login_retrieve_password: 'Wachtwoord Terughalen',
  main_login_btn_text: 'Inloggen',
  main_login_account_tip: 'Voer uw account in',
  main_login_password_tip: 'Voer uw wachtwoord in',
  main_login_accountMap_LDAP: 'Domein',
  main_login_accountMap_SYS: 'GOFO-systeem',
  main_login_accountMap_CAS: 'ZongTeng Intranet',
  main_login_account_error: 'Account of wachtwoord onjuist',
  main_login_retrieve_back: 'Terug',
  main_login_select_account: 'Selecteer Account om Terug te Halen',
  main_login_select_way: 'Kies Terughaalwijze',
  main_login_authentication: 'Identiteitsverificatie',
  main_login_reset_password: 'Wachtwoord Herstellen',
  main_login_work_number: 'Personeelsnummer',
  main_login_work_number_tip: 'Voer het terug te halen personeelsnummer in',
  main_login_customer_tip: 'U voert een wachtwoordherstelbewerking uit voor',
  main_login_operation_tip: 'om het wachtwoord te herstellen',
  main_login_verification_code: 'Klik om verificatiecode te krijgen, e-mail wordt naar uw mailbox verzonden',
  main_login_verification_code_tip: 'Voer de verificatiecode in',
  main_login_send_verification_code: 'Verificatiecode Versturen',
  main_login_name: 'Naam',
  main_login_new_password: 'Nieuw Wachtwoord',
  main_login_new_password_tip: 'Voer een nieuw wachtwoord in',
  main_login_new_password_again_tip: 'Voer het nieuwe wachtwoord opnieuw in',
  main_login_next_step: 'Volgende',
  main_login_save: 'Opslaan',
  main_login_reset_password_succeeded: 'Wachtwoord hersteld, log opnieuw in',
  main_login_work_number_input: 'Voer personeelsnummer in',
  main_login_six_verification_code: 'Voer de 6-cijferige verificatiecode in',
  main_login_mail: 'Via E-mail',
  main_login_unknown_way: 'Onbekende verificatiemethode',
  main_login_get_in: 'Systeem betreden, even geduld',
  main_login_no_exist_page: 'U heeft geen toestemming of deze pagina bestaat niet',
  main_login_no_exist_page_tip: 'Controleer of het pad correct is, of klik op de knop om terug te gaan naar de homepage. Bij problemen neem contact op met de beheerder',
  main_login_no_exist_back: 'Terug naar Homepage',
  main_login_no_last_back: 'Terug naar Vorige Pagina',
  main_login_link_not_exist: 'Link bestaat niet',
  main_login_privacy_agree: 'Door door te gaan, gaat u akkoord met onze',
  main_login_privacy_title_1: 'Gebruiksvoorwaarden',
  main_login_privacy_confirm: 'en bevestigt u dat u onze',
  main_login_privacy_title_2: 'Privacyverklaring',
  main_login_privacy_tip: 'Lees alstublieft onze voorwaarden door voordat u inlogt',
  main_login_privacy_think_btn: 'Denk opnieuw na',
  main_login_privacy_agree_btn: 'Akkoord',
  main_login_privacy_with: 'met'
  // #endregion
}
